import React from "react";
import unveil1 from "../../images/unveil_1.png";
import LeftSidebar1 from "../../images/svg/LeftSidebar1.svg";
import LeftSidebar1Inactive from "../../images/svg/LeftSidebar1Inactive.svg";
import PipelineTabActiveIcon from "../../images/svg/PipelineTabActiveIcon.svg";
import PipelineTabInactiveIcon from "../../images/svg/PipelineTabInactiveIcon.svg";
import LeftSidebar2 from "../../images/svg/LeftSidebar2.svg";
import LeftSidebar2Active from "../../images/svg/LeftSidebar2Active.svg";
import LeadsInactive from "../../images/svg/LeadsInactive.svg";
import LeadsActive from "../../images/svg/LeadsActive.svg";
import activeSidebar from "../../images/svg/activeSidebar.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";


function LeftSidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useAuth(); // Add this

    const handleLogout = async () => {
        try {
            console.log("Running logout");
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout failed:', error);
            // Optionally add error handling/notification here
        }
    };

    // console.log(`locations:`, location);
    return (
        <div className="lg:col-span-1 border-r-2 h-screen flex flex-col sticky top-0 [@media(max-width:1027px)]:hidden">
            <div className="px-8 pt-9 pb-7">
                <img src={unveil1} alt="unveil" className="w-[7rem]" />
            </div>

            <div className="flex-1 px-8 py-4">
                <ul className="space-y-6">
                    {/* <li className="flex items-end text-gray-800 hover:text-purple-600 cursor-pointer" onClick={() => navigate('/companies')}>

                        <span className="flex items-center justify-center mr-2 relative">
                            {location.pathname.includes(`/companies`)
                                ? <img src={activeSidebar} alt="" className="absolute left-[-32px]" />
                                : ''
                            }
                            <img src={location.pathname.includes(`/companies`)
                                ? LeftSidebar1
                                : LeftSidebar1Inactive} alt="Companies" style={{ width: '16px', maxWidth: "max-content" }}
                            />
                        </span>
                        <span className={`text-[${location.pathname.includes(`/companies`) ? `#45185A` : `#757575`}] text-xs font-[500]`}>
                            Companies
                        </span>
                    </li>
                
                    <li className="flex items-end text-gray-800 hover:text-purple-600 cursor-pointer" onClick={() => navigate('/pipeline')}>
                        <span className="flex items-center justify-center mr-2 relative">
                            {location.pathname.includes(`/pipeline`)
                                ? <img src={activeSidebar} alt="" className="absolute left-[-32px]" />
                                : ''}
                            <img src={location.pathname.includes(`/pipeline`) ? PipelineTabActiveIcon : PipelineTabInactiveIcon} alt="Pipeline" style={{ width: '16px', maxWidth: "max-content" }} />
                        </span>
                        <span className={`text-[${location.pathname.includes(`/pipeline`) ? `#45185A` : `#757575` }] text-xs font-[500]`}>
                            Pipeline
                        </span>
                    </li> */}
                   

                    <li className="flex items-end text-gray-800 hover:text-purple-600 cursor-pointer" onClick={() => navigate('/leads')}>
                        <span className="flex items-center justify-center mr-2 relative">
                            {location.pathname.includes(`/leads`) || location.pathname.includes(`/generate-leads`)
                                ? <img src={activeSidebar} alt="" className="absolute left-[-32px]" />
                                : ''
                            }
                            <img src={location.pathname.includes(`/leads`) || location.pathname.includes(`/generate-leads`)
                                ? LeadsActive
                                : LeadsInactive} alt="leads" style={{ width: '16px', maxWidth: "max-content" }}
                            />
                        </span>
                        <span className={`text-[${location.pathname.includes(`/leads`) || location.pathname.includes(`/generate-leads`) ? `#45185A` : `#757575`}] text-xs font-[500]`}>
                            Leads
                        </span>
                    </li>
                    {/* <li className="flex items-end text-gray-800 hover:text-purple-600 cursor-pointer" onClick={() => navigate(`/integrations`)}>
                        <span className="flex items-center justify-center mr-2 relative">
                            {location.pathname.includes(`/integrations`)
                                ? <img src={activeSidebar} alt="" className="absolute left-[-32px]" />
                                : ''
                            }

                            <img src={location.pathname.includes(`/integrations`)
                                ? LeftSidebar2Active
                                : LeftSidebar2
                            } alt="integrations" style={{ width: `${location.pathname.includes(`/integrations`) ? `20px` : '16px'}`, maxWidth: "max-content" }}
                            />
                        </span>
                        <span className={`text-[${location.pathname.includes(`/integrations`) ? `#45185A` : `#757575`}] text-xs font-[500]`}>
                            Integrations
                        </span>
                    </li> */}
                    {/* <li className="flex items-end text-gray-800 hover:text-purple-600 cursor-pointer">
                        <span className="flex items-center justify-center mr-2">
                            <img src={LeftSidebar3} alt="automations" style={{ width: '16px', maxWidth: "max-content" }} />
                        </span>
                        <span className="text-[#757575] text-xs font-[500]">
                            Automations
                        </span>
                    </li> */}

                </ul>
            </div>

            {/* Logout Section */}
            <div className="p-8">
                <button className="text-[#757575] text-sm" onClick={handleLogout}>
                    Log Out
                </button>
            </div>
        </div>
    );
}

export default LeftSidebar;
